var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "rotate(-90 4 4)",
    fill: "#CFCFCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 -1.74846e-07C4.6578 -2.03599e-07 5.30546 0.162228 5.88559 0.472315C6.46572 0.782401 6.96042 1.23077 7.32588 1.77772C7.69133 2.32466 7.91626 2.95329 7.98074 3.60793C8.04521 4.26257 7.94725 4.923 7.69552 5.53073C7.44379 6.13846 7.04606 6.67473 6.53757 7.09204C6.02908 7.50935 5.42553 7.79481 4.78036 7.92314C4.1352 8.05147 3.46834 8.01871 2.83886 7.82776C2.20938 7.63681 1.63671 7.29356 1.17157 6.82843L4 4L4 -1.74846e-07Z",
    fill: "#ED6C02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 -1.74846e-07C4.79112 -2.09427e-07 5.56448 0.234596 6.22228 0.674121C6.88008 1.11365 7.39277 1.73836 7.69552 2.46927C7.99827 3.20017 8.07748 4.00444 7.92314 4.78036C7.7688 5.55629 7.38784 6.26902 6.82843 6.82843L4 4L4 -1.74846e-07Z",
    fill: "#2E7D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.890ca57e95fbe60a7c48011b110e3228.svg";
export { ForwardRef as ReactComponent };